module.exports = __webpack_public_path__ + "img/campus-small-1.73532554.jpg";